var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-button',_vm._b({on:{"click":_vm.handleTest}},'a-button',_vm.config,false),[_vm._v(_vm._s(_vm.$t('common_269')))])
}
var staticRenderFns = []

export { render, staticRenderFns }